import useTranslation from 'next-translate/useTranslation';
import { PauseIcon, PlayIcon } from '../../icons';
import IconButton from '../IconButton';
import TooltipWrapper from '../TooltipWrapper';

export interface IPlayControlProps {
  paused: boolean;
  onClick: () => void;
  className?: string;
}

const PlayControl = ({ paused, onClick, className }: IPlayControlProps) => {
  const { t } = useTranslation('common');
  const tooltipText = paused ? t('tooltips.play') : t('tooltips.pause');

  return (
    <TooltipWrapper tooltipText={tooltipText} tooltipPosition='top'>
      <IconButton
        data-testid='play-control'
        className={className}
        onClick={onClick}
        icon={paused ? <PlayIcon data-testid='play-icon' /> : <PauseIcon data-testid='pause-icon' />}
      />
    </TooltipWrapper>
  );
};

export default PlayControl;
